import { render } from "./filterIcons.vue?vue&type=template&id=3869c6f8"
import script from "./filterIcons.vue?vue&type=script&lang=js"
export * from "./filterIcons.vue?vue&type=script&lang=js"
script.render = render

export default script